import { Box } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { Header } from '../Header/Header';
import { PageGradient } from '../PageGradient/PageGradient';
import { Footer } from '../Footer/Footer';

type Props = {
  children: ReactNode;
};

export const Layout = React.memo(({ children }: Props) => {
  return (
    <>
      <Header />
      <PageGradient />
      <Box as="main" flexGrow={1} py={{ base: '36px', lg: '54px' }} px={{ base: '20px', sm: '40px', md: '77.5px' }} minW={'100%'}>
        {children}
      </Box>
      <Footer />
    </>
  );
});
